// ═══════════════════════════════════════════════════════════════════════════════
// Persistent reminder: employer can use the app before a Helper joins
// ═══════════════════════════════════════════════════════════════════════════════

import { Link } from 'react-router-dom';
import { USER_ROLE } from '@fdh/shared';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';

const isPaired = (pairedAt: string | undefined): boolean =>
  Boolean(pairedAt && pairedAt.trim() !== '');

export const UnpairedEmployerBanner = () => {
  const { t } = useLanguage();
  const { user } = useAuth();

  if (!user || user.role !== USER_ROLE.EMPLOYER || isPaired(user.pairedAt)) {
    return null;
  }

  return (
    <div
      className="border-b border-amber-200 bg-amber-50 px-4 py-3 dark:border-amber-900/50 dark:bg-amber-950/40"
      role="note"
      aria-label={t('pairing.unpairedBannerAria')}
    >
      <div className="mx-auto flex max-w-lg flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm leading-relaxed text-amber-950 dark:text-amber-100">
          {t('pairing.unpairedBanner')}
        </p>
        <Link
          to="/pairing/generate-code"
          className="inline-flex min-h-11 shrink-0 items-center justify-center rounded-lg bg-amber-700 px-4 text-sm font-semibold text-white hover:bg-amber-800 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2 dark:bg-amber-600 dark:hover:bg-amber-500"
          aria-label={t('pairing.unpairedBannerAction')}
        >
          {t('pairing.unpairedBannerAction')}
        </Link>
      </div>
    </div>
  );
};
